import React, { useEffect, useState } from "react";

import classNames from "classnames";
import { getUserDataWithId } from "../../../common/data/userDummyData";

import Page from "../../../layout/Page/Page";

import Card, {
  CardBody,
  CardHeader,
  CardLabel,
  CardTitle,
} from "../../../components/bootstrap/Card";
import Avatar from "../../../components/Avatar";
import Icon from "../../../components/icon/Icon";

import dummyEventsData from "../../../common/data/dummyEventsData";

import Alert from "../../../components/bootstrap/Alert";
import useDarkMode from "../../../hooks/useDarkMode";

export interface IUserProps {
  userId: number;
  userName: string; // Change this from 'username'
  userEmail: string;
  createdTabs: number;
  createdDashboards: number;
  createdWidgets: number;
  createdQueries: number;
  userRoles: string[];
  userGroups: string[];
}

const EmployeePage = () => {
  const vyu_api_url = process.env.REACT_APP_VYU_API_URL;
  const { darkModeStatus } = useDarkMode();
  const [userData, setUserData] = useState<IUserProps | null>(null);
  const [activeView, setActiveView] = useState("roles");
  const companyInfo: any = localStorage.getItem("companyInfo");
  const parsedCompanyInfo = JSON.parse(companyInfo);

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const data = getUserDataWithId("1");

  const fetchUserProfile = async () => {
    try {
      const token = localStorage.getItem("token");
      // Make API call to fetch query options
      const response = await fetch(`${vyu_api_url}/profile/view`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      console.log("This is user profile data", data);
      setUserData(data.obj);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  if (!data) {
    return <div>Error: Employee not found</div>;
  }

  const userTasks = dummyEventsData.filter(
    (f) => f.assigned.username === data?.username
  );

  return (
    <>
      <div title={`${userData?.userName}`}>
        <div className="company-info">
          <img
            src={parsedCompanyInfo.companyLogo}
            alt="Proeffective Logo"
            className="company-logo"
          />
          {parsedCompanyInfo.show === true && (
            <span className="vyu-text">{parsedCompanyInfo.companyName}</span>
          )}
        </div>
        <Page>
          <div className="pt-3 pb-5 d-flex align-items-center">
            <span className="display-4 fw-bold me-3">{`${userData?.userName}`}</span>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <Card className="shadow-3d-info">
                <CardBody>
                  <div className="row g-5">
                    <div className="col-12 d-flex justify-content-center">
                      <Avatar
                        src={data.src}
                        srcSet={data.srcSet}
                        color={data.color}
                        isOnline={data.isOnline}
                      />
                    </div>
                    <div className="col-12">
                      <div className="row g-2">
                        <div className="col-12">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <Icon icon="Mail" size="3x" color="info" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <div className="fw-bold fs-5 mb-0">
                                {`${userData?.userEmail}`}
                              </div>
                              <div className="text-muted">Email Address</div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <Icon icon="Tag" size="3x" color="info" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <div className="fw-bold fs-5 mb-0">
                                {`@${userData?.userName}`}
                              </div>
                              <div className="text-muted">Social name</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <CardLabel icon="ShowChart" iconColor="secondary">
                    <CardTitle tag="div" className="h5">
                      Created By User
                    </CardTitle>
                  </CardLabel>
                </CardHeader>
                <CardBody>
                  <div className="row g-4 align-items-center">
                    <div className="col-xl-6">
                      <div
                        className={classNames(
                          "d-flex align-items-center rounded-2 p-3",
                          {
                            "bg-l10-warning": !darkModeStatus,
                            "bg-lo25-warning": darkModeStatus,
                          }
                        )}
                      >
                        <div className="flex-shrink-0">
                          <Icon icon="Widgets" size="3x" color="warning" />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <div className="fw-bold fs-3 mb-0">
                            {" "}
                            {userData?.createdWidgets}
                          </div>
                          <div className="text-muted mt-n2 truncate-line-1">
                            Widgets
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div
                        className={classNames(
                          "d-flex align-items-center rounded-2 p-3",
                          {
                            "bg-l10-info": !darkModeStatus,
                            "bg-lo25-info": darkModeStatus,
                          }
                        )}
                      >
                        <div className="flex-shrink-0">
                          <Icon icon="Search" size="3x" color="info" />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <div className="fw-bold fs-3 mb-0">
                            {" "}
                            {userData?.createdQueries}
                          </div>
                          <div className="text-muted mt-n2 truncate-line-1">
                            Queries
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div
                        className={classNames(
                          "d-flex align-items-center rounded-2 p-3",
                          {
                            "bg-l10-primary": !darkModeStatus,
                            "bg-lo25-primary": darkModeStatus,
                          }
                        )}
                      >
                        <div className="flex-shrink-0">
                          <Icon icon="Tab" size="3x" color="primary" />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <div className="fw-bold fs-3 mb-0">
                            {" "}
                            {userData?.createdTabs}
                          </div>
                          <div className="text-muted mt-n2 truncate-line-1">
                            Tabs
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div
                        className={classNames(
                          "d-flex align-items-center rounded-2 p-3",
                          {
                            "bg-l10-success": !darkModeStatus,
                            "bg-lo25-success": darkModeStatus,
                          }
                        )}
                      >
                        <div className="flex-shrink-0">
                          <Icon icon="Dashboard" size="3x" color="success" />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <div className="fw-bold fs-3 mb-0">
                            {" "}
                            {userData?.createdDashboards}
                          </div>
                          <div className="text-muted mt-n2">Dashboards</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
            <div className="col-lg-8">
              <Card className="shadow-3d-primary">
                <CardHeader>
                  <CardLabel icon="Summarize" iconColor="success">
                    <CardTitle tag="div" className="h5">
                      User has an Access
                    </CardTitle>
                  </CardLabel>
                </CardHeader>
                <CardBody>
                  <div className="row g-4">
                    <div className="col-md-6">
                      <Card
                        className={`bg-l${
                          darkModeStatus ? "o25" : "25"
                        }-primary bg-l${
                          darkModeStatus ? "o50" : "10"
                        }-primary-hover transition-base rounded-2 mb-4`}
                        shadow="sm"
                      >
                        <CardHeader className="bg-transparent">
                          <CardLabel>
                            <CardTitle tag="div" className="h5">
                              Total Widgets
                            </CardTitle>
                          </CardLabel>
                        </CardHeader>
                        <CardBody>
                          <div className="d-flex align-items-center pb-3">
                            <div className="flex-shrink-0">
                              <Icon icon="Widgets" size="4x" color="primary" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <div className="fw-bold fs-3 mb-0">20</div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                      <Card
                        className={`bg-l${
                          darkModeStatus ? "o25" : "25"
                        }-danger bg-l${
                          darkModeStatus ? "o50" : "10"
                        }-danger-hover transition-base rounded-2 mb-0`}
                        shadow="sm"
                      >
                        <CardHeader className="bg-transparent">
                          <CardLabel>
                            <CardTitle tag="div" className="h5">
                              Total Tabs
                            </CardTitle>
                          </CardLabel>
                        </CardHeader>
                        <CardBody>
                          <div className="d-flex align-items-center pb-3">
                            <div className="flex-shrink-0">
                              <Icon icon="Tab" size="4x" color="danger" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <div className="fw-bold fs-3 mb-0">6</div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                    <div className="col-md-6">
                      <Card
                        className={`bg-l${
                          darkModeStatus ? "o25" : "25"
                        }-primary bg-l${
                          darkModeStatus ? "o50" : "10"
                        }-success-hover transition-base rounded-2 mb-4`}
                        shadow="sm"
                      >
                        <CardHeader className="bg-transparent">
                          <CardLabel>
                            <CardTitle tag="div" className="h5">
                              Dashboards
                            </CardTitle>
                          </CardLabel>
                        </CardHeader>
                        <CardBody className="pt-0">
                          <div className="d-flex align-items-center pb-3">
                            <div className="flex-shrink-0">
                              <Icon
                                icon="Dashboard"
                                size="4x"
                                color="success"
                              />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <div className="fw-bold fs-3 mb-0">~2</div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                      <Card
                        className={`bg-l${
                          darkModeStatus ? "o25" : "25"
                        }-success bg-l${
                          darkModeStatus ? "o50" : "10"
                        }-success-hover transition-base rounded-2 mb-4`}
                        shadow="sm"
                      >
                        <CardHeader className="bg-transparent">
                          <CardLabel>
                            <CardTitle tag="div" className="h5">
                              Total Queries
                            </CardTitle>
                          </CardLabel>
                        </CardHeader>
                        <CardBody>
                          <div className="d-flex align-items-center pb-3">
                            <div className="flex-shrink-0">
                              <Icon icon="Search" size="4x" color="primary" />
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <div className="fw-bold fs-3 mb-0">50</div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <CardLabel icon="Task" iconColor="danger">
                    <CardTitle>
                      <CardLabel tag="div" className="h5">
                        {activeView === "roles" ? "Roles" : "Groups"}
                      </CardLabel>
                    </CardTitle>
                  </CardLabel>
                </CardHeader>
                <CardBody>
                  <div className="d-flex justify-content-left mb-3">
                    <button
                      className={`btn btn-sm me-2 ${activeView === "roles" ? "btn-primary" : "btn-outline-primary"}`}
                      onClick={() => setActiveView("roles")}
                    >
                      Roles
                    </button>
                    <button
                      className={`btn btn-sm ${activeView === "groups" ? "btn-primary" : "btn-outline-primary"}`}
                      onClick={() => setActiveView("groups")}
                    >
                      Groups
                    </button>
                  </div>

                  <>
                    <table
                      style={{
                        borderCollapse: "collapse", // collapse to show clear borders
                        width: "100%",
                        borderWidth: "0px",
                        backgroundColor: "transparent",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            S.NO
                          </th>
                          <th
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {activeView === "roles"
                              ? "Role Name"
                              : "Group Name"}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {(activeView === "roles"
                          ? userData?.userRoles
                          : userData?.userGroups
                        )?.map((item, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                border: "1px solid #ccc",
                                padding: "8px",
                              }}
                            >
                              {index + 1}
                            </td>
                            <td
                              style={{
                                border: "1px solid #ccc",
                                padding: "8px",
                              }}
                            >
                              {item}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>

                  {userData === null && (
                    <Alert
                      color="warning"
                      isLight
                      icon="Report"
                      className="mt-3"
                    >
                      There is no scheduled task for{" "}
                      {activeView === "roles" ? "Roles" : "Groups"}.
                    </Alert>
                  )}
                </CardBody>
              </Card>
              {/* <Card>
                <CardHeader>
                  <CardLabel icon="Task" iconColor="danger">
                    <CardTitle>
                      <CardLabel tag="div" className="h5">
                        Assigned
                      </CardLabel>
                    </CardTitle>
                  </CardLabel>
                </CardHeader>
                <CardBody>
                  <div className="table-responsive">
                    <table className="table table-modern mb-0">
                      <thead>
                        <tr>
                          <th>Date / Time</th>
                          <th>Customer</th>
                          <th>Service</th>
                          <th>Duration</th>
                          <th>Payment</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userTasks.map((item) => (
                          <tr key={item.id}>
                            <td>
                              <div className="d-flex align-items-center">
                                <span
                                  className={classNames(
                                    "badge",
                                    "border border-2 border-light",
                                    "rounded-circle",
                                    "bg-success",
                                    "p-2 me-2",
                                    `bg-${item.status.color}`
                                  )}
                                >
                                  <span className="visually-hidden">
                                    {item.status.name}
                                  </span>
                                </span>
                                <span className="text-nowrap">
                                  {dayjs(`${item.date} ${item.time}`).format(
                                    "MMM Do YYYY, h:mm a"
                                  )}
                                </span>
                              </div>
                            </td>
                            <td>
                              <div>
                                <div>{item.customer.name}</div>
                                <div className="small text-muted">
                                  {item.customer.email}
                                </div>
                              </div>
                            </td>
                            <td>{item.service.name}</td>
                            <td>{item.duration}</td>
                            <td>{item.payment && priceFormat(item.payment)}</td>
                            <td>
                              <Dropdown>
                                <DropdownToggle hasIcon={false}>
                                  <Button
                                    isLink
                                    color={item.status.color}
                                    icon="Circle"
                                    className="text-nowrap"
                                  >
                                    {item.status.name}
                                  </Button>
                                </DropdownToggle>
                                <DropdownMenu>
                                  {Object.keys(EVENT_STATUS).map((key) => (
                                    <DropdownItem key={key}>
                                      <div>
                                        <Icon
                                          icon="Circle"
                                          color={EVENT_STATUS[key].color}
                                        />
                                        {EVENT_STATUS[key].name}
                                      </div>
                                    </DropdownItem>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {!userTasks.length && (
                    <Alert
                      color="warning"
                      isLight
                      icon="Report"
                      className="mt-3"
                    >
                      There is no scheduled and assigned task.
                    </Alert>
                  )}
                </CardBody>
              </Card> */}
            </div>
          </div>
        </Page>
      </div>
    </>
  );
};

export default EmployeePage;
